import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {Editor} from '../editor-components';
import Spinner from '../spinner/spinner';
import BoothMetadata from './booth-metadata';
import ScreenEmulator from '../screen-emulator/screen-emulator';
import ContentsList from './contents-list';

/** @class BothEditor
  * A component for editing booths and thier contents
  * in a virutal expo.
  */
export default class BoothEditor extends ReactFireComponent {
  /** @constructor
    * Creates a new BoothEditor component
    */
  constructor(props) {
    super(props);
    const expoID = props.match.params.expoID
    const showID = props.match.params.showID
    const boothID = props.match.params.boothID
    this.state = {
      expoID: expoID,
      showID: showID,
      boothID: boothID
    }
    this.dataURL = `/expos/${expoID}/shows/${showID}/booths/${boothID}`;
    this.hallURL = `/expos/${expoID}/shows/${showID}/halls`;
  }
  /** @function componentWillMount
    * Connects the component to its corresponding
    * data in the Firebase realtime database
    */
  componentWillMount() {
    this.bindAsObject(this.dataURL, 'booth');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the
    * Firebase realtime database
    */
  componentWillUnmount() {
    this.unbind('booth');
  }
  /** @function render
    * Renders the component
    */
  render(){
    if(!this.state.booth) return <Spinner />
    return(
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Properties</Tab>
            <Tab>Contents</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <BoothMetadata {...this.state.booth}
              boothID={this.state.boothID}
              dataURL={this.dataURL}
              hallURL={this.hallURL}
              />
          </TabPanel>
          <TabPanel>
            <div className="content-tab">
              <div className="sidebar">
                <ContentsList contents={this.state.booth.contents} dataURL={this.dataURL + '/contents'} />
              </div>
              <div className="screen">
                <ScreenEmulator src={`/preview/${this.state.expoID}/${this.state.showID}/#/booth/${this.state.boothID}/contents`} />
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <ScreenEmulator src={`/preview/${this.state.expoID}/${this.state.showID}/#/booth/${this.state.boothID}`} />
          </TabPanel>
        </Tabs>
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-editor/booth-editor.js